module.exports = __webpack_public_path__ + "static/media/starterguidestep1.3d2291fc.png";